"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _Icon = require("../../media/icon/Icon");
var _ = require("../..");
var _alert = require("./alert.tokens");
var _types = require("./types");
var _InnerButton = require("../../controls/buttons/InnerButton");
var _button = require("../../controls/buttons/button.tokens");
var _flex = require("../../layout/flex");
var _jsxRuntime = require("react/jsx-runtime");
var LeftSide = _styledComponents.default.div.withConfig({
  displayName: "Alert__LeftSide",
  componentId: "sc-fdt21d-0"
})(["display:flex;align-items:center;gap:", ";padding:2px 0;min-height:", ";"], _tokens.default.sky.sys.spacing['300'], function (props) {
  return (0, _button.buttonTokens)(props.theme).size.height;
});
var RightSide = _styledComponents.default.div.withConfig({
  displayName: "Alert__RightSide",
  componentId: "sc-fdt21d-1"
})(["display:flex;align-items:flex-end;"]);
var DismissWrapper = _styledComponents.default.div.withConfig({
  displayName: "Alert__DismissWrapper",
  componentId: "sc-fdt21d-2"
})(["padding-left:", ";"], _tokens.default.sky.sys.spacing['300']);
var ChildrenWrapper = _styledComponents.default.div.withConfig({
  displayName: "Alert__ChildrenWrapper",
  componentId: "sc-fdt21d-3"
})(["padding-right:", ";"], _tokens.default.sky.sys.spacing['300']);
var NonVisualButtonStyled = (0, _styledComponents.default)(_InnerButton.NonVisualButton).withConfig({
  displayName: "Alert__NonVisualButtonStyled",
  componentId: "sc-fdt21d-4"
})(["border-left:solid ", " ", ";"], _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative);
var AlertWrapper = _styledComponents.default.div.withConfig({
  displayName: "Alert__AlertWrapper",
  componentId: "sc-fdt21d-5"
})(["display:flex;justify-content:space-between;padding:", " ", " ", " ", ";background:", ";border-left:solid ", " ", ";border-top:solid ", " ", ";border-right:solid ", " ", ";border-bottom:solid ", " ", ";border-radius:", ";"], _tokens.default.sky.sys.spacing['200'], _tokens.default.sky.sys.spacing['400'], _tokens.default.sky.sys.spacing['200'], _tokens.default.sky.sys.spacing['300'], function (_ref) {
  var $type = _ref.$type,
    theme = _ref.theme;
  return (0, _alert.alertTokens)(theme)[$type].background;
}, _tokens.default.sky.sys.spacing['300'], function (_ref2) {
  var $type = _ref2.$type,
    theme = _ref2.theme;
  return (0, _alert.alertTokens)(theme)[$type].barColor;
}, _tokens.default.sky.sys.size.borderwidth['thin'], function (_ref3) {
  var $type = _ref3.$type,
    theme = _ref3.theme;
  return (0, _alert.alertTokens)(theme)[$type].borderColor;
}, _tokens.default.sky.sys.size.borderwidth['thin'], function (_ref4) {
  var $type = _ref4.$type,
    theme = _ref4.theme;
  return (0, _alert.alertTokens)(theme)[$type].borderColor;
}, _tokens.default.sky.sys.size.borderwidth['thin'], function (_ref5) {
  var $type = _ref5.$type,
    theme = _ref5.theme;
  return (0, _alert.alertTokens)(theme)[$type].borderColor;
}, _tokens.default.sky.sys.size.borderradius['2']);
var Alert = function Alert(_ref6) {
  var _ref6$type = _ref6.type,
    type = _ref6$type === void 0 ? _types.AlertType.INFORMATION : _ref6$type,
    text = _ref6.text,
    onDismiss = _ref6.onDismiss,
    children = _ref6.children;
  var theme = (0, _styledComponents.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(AlertWrapper, {
    $type: type,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(LeftSide, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        size: 'l',
        icon: (0, _alert.alertTokens)(theme)[type].icon,
        customColor: (0, _alert.alertTokens)(theme)[type].iconColor
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
        children: text
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(RightSide, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ChildrenWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flex.FlexRow, {
          gap: 'm',
          children: [children, " "]
        })
      }), !!onDismiss && /*#__PURE__*/(0, _jsxRuntime.jsx)(NonVisualButtonStyled, {
        onClick: onDismiss,
        "aria-label": 'dismiss',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DismissWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            icon: 'close'
          })
        })
      })]
    })]
  });
};
Alert.TYPE = _types.AlertType;
var _default = exports.default = Alert;